import { useRef } from 'react'

export const useIdempotentClientMessageId = () => {
  const pendingRef = useRef<{ payload: string, clientMessageId: string } | null>(null)

  const idFor = (conversationId: string, content: string, attachmentIds: string[]): string => {
    const payload = JSON.stringify([conversationId, content, attachmentIds])
    if (pendingRef.current?.payload !== payload) {
      pendingRef.current = { payload, clientMessageId: crypto.randomUUID() }
    }
    return pendingRef.current.clientMessageId
  }

  const release = () => {
    pendingRef.current = null
  }

  return { idFor, release }
}
